import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Spin, Button, Select, message } from 'antd';

import { IMPORT_OPTIONS } from './ImportPageConstants';
import UpdateImportModal from './components/UpdateImportModal';
import { getImportFormat } from '../../redux/action/import/ImportActions';

import './ImportPage.css';
import UpdatePureImportModal from './components/UpdatePureImportModal';

const { Option } = Select;

class ImportPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaderIsVisible: false,
      showImportModal: false,
      importSelect: '',
      actionStatus: '',
      showPureImportModal: false,
      actionPureStatus: '',
      importPureSelect: ''
    };
  }

  componentDidMount() {
    if (!this.props.userInfo.userPermissions.importPermission) {
      window.location = '/403';
    }
  }

  closeModalHandler = () => {
    this.setState({
      showImportModal: false,
      importSelect: ''
    });
  };

  closePureModalHandler = () => {
    this.setState({
      showPureImportModal: false,
      importPureSelect: ''
    });
  };

  selectChangeHandler = (val) => {
    this.setState({
      importSelect: val
    });
  };

  handleLoader = (state) => {
    this.setState({
      loaderIsVisible: state
    });
  };

  importModalHandler = (actionStatus) => {
    if (this.state.importSelect) {
      Promise.resolve(this.props.getImportFormat(this.state.importSelect)).then(
        () => {
          this.setState({
            showImportModal: true,
            actionStatus: actionStatus
          });
        }
      );
    } else {
      message.error('Item field can not be empty!');
    }
  };

  pureImportModalHandler = (actionStatus, key) => {
    if (key) {
      Promise.resolve(this.props.getImportFormat(key)).then(() => {
        this.setState({
          showPureImportModal: true,
          actionPureStatus: actionStatus,
          importPureSelect: key
        });
      });
    } else {
      message.error('Item field can not be empty!');
    }
  };

  render() {
    return (
      <Spin size='large' spinning={this.state.loaderIsVisible}>
        <div className='filter-container'>
          <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24'>
            <div
              className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-8 ant-col-xl-8'
              style={{
                padding: '0',
                marginBottom: '1rem',
                display: 'flex',
                gap: '15px'
              }}
            >
              <Select
                placeholder='Please select items to update'
                // value={this.state.importSelect}
                allowClear
                onChange={(val) => this.selectChangeHandler(val)}
                style={{ width: '100%' }}
              >
                {_.map(IMPORT_OPTIONS, (option) => (
                  <Option key={option.key} value={option.key}>
                    {option.title}
                  </Option>
                ))}
              </Select>
            </div>
            <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 m-b-25'>
              <div
                className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-2 ant-col-xl-2'
                style={{ display: 'flex' }}
              >
                <Button
                  type='primary'
                  onClick={() => this.importModalHandler('update')}
                  style={{ marginRight: '1rem' }}
                >
                  Manual entry
                </Button>
                <Button
                  type='primary'
                  onClick={() => this.importModalHandler('import')}
                >
                  Import CSV
                </Button>
              </div>
              <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24'>
                <UpdateImportModal
                  modalStatus={this.state.actionStatus}
                  selectKey={this.state.importSelect}
                  isVisible={this.state.showImportModal}
                  loaderIsVisible={this.state.loaderIsVisible}
                  setLoader={this.handleLoader}
                  onCancel={this.closeModalHandler}
                />
                <UpdatePureImportModal
                  modalStatus={this.state.actionPureStatus}
                  selectKey={this.state.importPureSelect}
                  isVisible={this.state.showPureImportModal}
                  loaderIsVisible={this.state.loaderIsVisible}
                  setLoader={this.handleLoader}
                  onCancel={this.closePureModalHandler}
                />
              </div>
            </div>
            <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 m-b-25'>
              <h2 className='dropdownbox-title'>
                Import Agency & Countries Sections
              </h2>

              <Button
                type='primary'
                onClick={() => this.pureImportModalHandler('import', 'agency')}
                style={{ marginRight: '1rem' }}
              >
                Import Legitimate Agency CSV
              </Button>

              <Button
                type='primary'
                onClick={() =>
                  this.pureImportModalHandler('import', 'countries')
                }
              >
                Import Countries CSV
              </Button>
            </div>
          </div>
        </div>
      </Spin>
    );
  }
}

function mapStateToProps({ auth }) {
  return {
    userInfo: auth.userInfo
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getImportFormat: bindActionCreators(getImportFormat, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ImportPage);
